module.exports = __webpack_public_path__ + "media/images/grid_preview_landscape-60bc7a7cee78b9fc564fecc337d3ba42.png";